(function() {
  'use strict';

  /**
   * @ngdoc object
   * @name crewStandByReport.controller:CrewStandByReportCtrl
   *
   * @description
   *
   */
  angular.module('crewPairingReport').controller('CrewPairingReportCtrl',
    CrewPairingReportCtrl);

  function CrewPairingReportCtrl(CommonMasterData, $sce, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'CrewPairingReportCtrl';
    vm.model = {
      searchPanelToggle : true,
      searchCriteria : {
        base:'',
        airCraftType:'',
        fromDate: moment().format("DD/MM/YYYY"),
        toDate: moment().format("DD/MM/YYYY"),
        flightNumber:'',
        airport:'',
        pairingName:'',
        isModifiedFlight:'All',
        isModifiedPairing:'B',
        pairingValidity:'B'
        // startPosition:1,
        // pageSize:50
      },
      masterList : {
        airportList : [],
        airCraftTypes : [],
        baseList : [],
        pairingValidity : [],
        modifyFlightList : [],
        pairings : [],
        commonSelectionCriteria : [],
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false,
        fromDateAfterToDate : false
      },
      initialSearchDone : false,
      reportDataURL : null,
      reportServerBaseUrl : null
    };

    // toggle search
    vm.clickOnSearch = function() {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    // submit search
    vm.submitSearch = function(params) {
      searchCrewPairingReport(params);
    };

    // on change search field
    vm.changeSearchField = function(searchParams, flag) {
      setDateValidationFlags();
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;
        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }
    };

    function setDateValidationFlags() {
      // if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      // if to date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    // check from date and to date
    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    }
    ;

    // check to date is a future date
    function istoDateFutureDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isAfter(moment().toDate());
    }
    ;

    // search Crew Water Consumption Report
    function searchCrewPairingReport(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;
        var reportDesign = "crew_pairing.rptdesign";
        var url = CommonLogicService.getReportUrl(reportDesign,
          getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
      }
    }


    // set search param map
    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["patternStartDate"] = param.fromDate;
      searchParamMap["patternEndDate"] = param.toDate;

      if(!angular.equals(param.base,"")){
        searchParamMap["baseAirportCode"] = param.base.airPortCode;
      }
      if(!angular.equals(param.airCraftType,"") && !angular.equals(param.airCraftType,undefined)) {
        searchParamMap["aircraftType"] = param.airCraftType.airCraftType;
      }
      searchParamMap["patternName"] = param.pairingName;
      searchParamMap["patternValidityType"] = param.pairingValidity;
      searchParamMap["patternModifyType"] = param.isModifiedPairing;
      searchParamMap["flightModifyType"] = param.isModifiedFlight;
      searchParamMap["flightNumber"] = param.flightNumber;
      if(!angular.equals(param.airport,"") && !angular.equals(param.airport," ")) {
        searchParamMap["airportCode"] = param.airport.airPortCode;
      }
      return searchParamMap;
    }

    function isValidSearchParams(params) {
      setDateValidationFlags();
      // if date invalid
      if (vm.model.masterList.toDateFormatInvalid
        || vm.model.masterList.fromDateFormatInvalid) {
        return false;
      } else if (istoDateBeforeFromDate()) {
        vm.model.masterList.fromDateAfterToDate = true;
        return false;
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
        return true;
      }
    }

    function getSearchPairingsValidity() {
      var listLocalSearchWithin = [
        {
          value: 'B',
          name: "all",
          text: "ALL",
          selected: true
        },
        {
          value: 'Y',
          name: "valid",
          text: "VALID",
          selected: false
        },
        {
          value: 'N',
          name: "invalid",
          text: "INVALID",
          selected: false
        }
      ];
      return listLocalSearchWithin;
    };

    function getCommonSelections() {
      var listLocalSelection = [
        {
          value: 'B',
          name: "all",
          text: "ALL",
          selected: true
        },
        {
          value: 'Y',
          name: "yes",
          text: "YES",
          selected: false
        },
        {
          value: 'N',
          name: "no",
          text: "NO",
          selected: false
        }
      ];
      return listLocalSelection;
    };

    function getFlightModifyList() {
      var listLocalSelection = [
        {
          value: 'All',
          name: "all ",
          text: "All ",
          selected: true
        },
        {
          value: 'C',
          name: "Cancelled ",
          text: "Cancelled ",
          selected: false
        },
        {
          value: 'D',
          name: "Deleted ",
          text: "Deleted ",
          selected: false
        },
        {
          value: 'M',
          name: "Modified ",
          text: "Modified ",
          selected: false
        },
        {
          value: 'N',
          name: "No ",
          text: "No ",
          selected: false
        }
      ];
      return listLocalSelection;
    };

    function searchPairingNameList() {
      var obj={};
      obj.fromDate = vm.model.searchCriteria.fromDate;
      obj.toDate= vm.model.searchCriteria.toDate;
      CommonMasterData.getPairingNames(obj, function(pairingList){
        angular.forEach(pairingList, function(name) {
          vm.model.masterList.pairings.push(" "+name+" ");
        });
      },function(error){

      });
    }

    function init() {
      CommonMasterData.getAirportList(function (airportList) {
        vm.model.masterList.airportList = airportList;
      }, function (error) {

      });
      CommonMasterData.getAircraftModels(function (airCraftList) {
        vm.model.masterList.airCraftTypes = airCraftList;
      }, function (error) {

      });
      CommonMasterData.getCrewBaseList(function (baseList) {
        vm.model.masterList.baseList = baseList;
        ManagePairing.setViewConfigByView(vm.model.viewMode);
        callLoadPairings();
      }, function (error) {

      });

      vm.model.masterList.commonSelectionCriteria = getCommonSelections();
      vm.model.masterList.pairingValidity = getSearchPairingsValidity();
      vm.model.masterList.modifyFlightList = getFlightModifyList();
      searchPairingNameList();

    }



    init();

  }
}());
